module.exports = __webpack_public_path__ + "img/shop_header_bg.90661db.png";